// extracted by mini-css-extract-plugin
export default {"Stenth":"Stenth_Stenth__0gGcE","wrap":"Stenth_wrap__Ohrz9","text":"Stenth_text__t2qIY","title":"Stenth_title__SK10C","desc":"Stenth_desc__dGCwR"};